module.exports = __webpack_public_path__ + "static/022.thumb-8a2fcda4cf0e625558aa1700f68d7e1a.jpg";